import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import logo from "../../../assets/images/karak_logo_new.png";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../helpers/show_notification";
import preloader from "../../../helpers/preloader";
import { formatUnitsForReport, mapUnits } from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";

const UserBasedTransactionReport = (props) => {
  const { SearchBar } = Search;
  const [monthYear, setMonthYear] = useState();
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();

  const [selectedRow, setSelectedRow] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isLoadingOrders, setIsLoadingOrders] = useState(true);
  const [isLoadingProductOrders, setIsLoadingProductOrders] = useState(false);
  const [isLoadingItemOrders, setIsLoadingItemOrders] = useState(false);
  const [isLoadingPurchaseOrders, setIsLoadingPurchaseOrders] = useState(false);
  const [isLoadingProductDetails, setIsLoadingProductDetails] = useState(false);
  const [isLoadingItemOrderDetails, setIsLoadingItemOrderDetails] =
    useState(false);
  const [isLoadingPurchaseDetails, setIsLoadingPurchaseDetails] =
    useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const productRequestId = useRef(0);
  const itemRequestId = useRef(0);
  const purchaseRequestId = useRef(0);
  const productDetailsRequestId = useRef(0);
  const itemDetailsRequestId = useRef(0);
  const purchaseDetailsRequestId = useRef(0);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    // setDateFrom(formatDate(firstDay));
    // setDateTo(formatDate(currentDay));
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
    loadOrders();
  }, []);

  const [allOrders, setAllOrders] = useState([]);
  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    setIsLoadingOrders(true);
    setAllOrders([]);
    setFilteredOrders([]);
    try {
      let url =
        process.env.REACT_APP_BASEURL + "reports/users_for_transactions";
      const response = await postSubmitForm(url, {});
      if (requestId !== ordersRequestId.current) return false;
      if (response && response.status === 1) {
        setGrandTotal(response.data.grand_total_cost);
        setAllOrders(response.data);
        setTablePage(1);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      showNotification(error.message || "Error", "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [directPurchaseDetails, setDirectPurchaseDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);

  const loadDirectPurchaseDetails = async (item_id) => {
    preloader(true);

    let url =
      process.env.REACT_APP_BASEURL +
      "reports/branchwise_costing_summary_direct_po";
    const response = await postSubmitForm(url, {
      branch_id: selectedRow._id,
      monthYear: monthYear,
      item_id: item_id,
    });
    if (response && response.status === 1) {
      preloader(false);
      // console.log(response.data);
      setDirectPurchaseDetails(response.data);
      setDirectPurchaseDetailsModal(!directPurchaseDetailsModal);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const loadItemDetails = async (item_id) => {
    preloader(true);

    let url =
      process.env.REACT_APP_BASEURL +
      "reports/branchwise_costing_summary_item_orders";
    const response = await postSubmitForm(url, {
      branch_id: selectedRow._id,
      monthYear: monthYear,
      item_id: item_id,
    });
    if (response && response.status === 1) {
      preloader(false);
      // console.log(response.data);
      setItemDetails(response.data);
      setItemDetailsModal(!itemDetailsModal);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const loadProductOrders = async (adminuser_id) => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setProductOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setProductOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }

    const requestId = ++productRequestId.current;
    setProductModal(true);
    setIsLoadingProductOrders(true);
    setProductOrders([]);
    try {
      let date_from = moment(dateFrom).format("YYYY-MM-DD");
      let date_to = moment(dateTo).format("YYYY-MM-DD");

      let url =
        process.env.REACT_APP_BASEURL + "reports/user_product_transactions";
      const response = await postSubmitForm(url, {
        date_from: date_from,
        date_to: date_to,
        adminuser_id: adminuser_id,
      });
      if (requestId !== productRequestId.current) return false;
      if (response && response.status === 1) {
        setProductOrders(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId !== productRequestId.current) return false;
      showNotification(error.message || "Error", "Error");
    } finally {
      if (requestId === productRequestId.current) {
        setIsLoadingProductOrders(false);
      }
    }
  };

  const loadProductOrderDetails = async (order_id) => {
    const requestId = ++productDetailsRequestId.current;
    setProductDetails({});
    setProductDetailsModal(true);
    setIsLoadingProductDetails(true);
    try {
      let url =
        process.env.REACT_APP_BASEURL + "reports/user_product_transactions";
      const response = await postSubmitForm(url, {
        adminuser_id: selectedRow._id,
        order_id: order_id,
      });
      if (requestId !== productDetailsRequestId.current) return false;
      if (response && response.status === 1) {
        setProductDetails((response.data && response.data[0]) || {});
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId !== productDetailsRequestId.current) return false;
      showNotification(error.message || "Error", "Error");
    } finally {
      if (requestId === productDetailsRequestId.current) {
        setIsLoadingProductDetails(false);
      }
    }
  };

  const loadItemOrders = async (adminuser_id) => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setProductOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setProductOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }

    const requestId = ++itemRequestId.current;
    setItemModal(true);
    setIsLoadingItemOrders(true);
    setItemOrders([]);
    try {
      let date_from = moment(dateFrom).format("YYYY-MM-DD");
      let date_to = moment(dateTo).format("YYYY-MM-DD");

      let url =
        process.env.REACT_APP_BASEURL + "reports/user_item_transactions";
      const response = await postSubmitForm(url, {
        date_from: date_from,
        date_to: date_to,
        adminuser_id: adminuser_id,
      });
      if (requestId !== itemRequestId.current) return false;
      if (response && response.status === 1) {
        setItemOrders(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId !== itemRequestId.current) return false;
      showNotification(error.message || "Error", "Error");
    } finally {
      if (requestId === itemRequestId.current) {
        setIsLoadingItemOrders(false);
      }
    }
  };

  const loadItemOrderDetails = async (order_id) => {
    const requestId = ++itemDetailsRequestId.current;
    setItemDetails({});
    setItemDetailsModal(true);
    setIsLoadingItemOrderDetails(true);
    try {
      let url =
        process.env.REACT_APP_BASEURL + "reports/user_item_transactions";
      const response = await postSubmitForm(url, {
        adminuser_id: selectedRow._id,
        order_id: order_id,
      });
      if (requestId !== itemDetailsRequestId.current) return false;
      if (response && response.status === 1) {
        setItemDetails((response.data && response.data[0]) || {});
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId !== itemDetailsRequestId.current) return false;
      showNotification(error.message || "Error", "Error");
    } finally {
      if (requestId === itemDetailsRequestId.current) {
        setIsLoadingItemOrderDetails(false);
      }
    }
  };

  const loadPurchaseOrders = async (adminuser_id) => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setPurchaseOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setPurchaseOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }

    const requestId = ++purchaseRequestId.current;
    setPurchaseModal(true);
    setIsLoadingPurchaseOrders(true);
    setPurchaseOrders([]);
    try {
      let date_from = moment(dateFrom).format("YYYY-MM-DD");
      let date_to = moment(dateTo).format("YYYY-MM-DD");

      let url =
        process.env.REACT_APP_BASEURL +
        "reports/user_purchaseorder_transactions";
      const response = await postSubmitForm(url, {
        date_from: date_from,
        date_to: date_to,
        adminuser_id: adminuser_id,
      });
      if (requestId !== purchaseRequestId.current) return false;
      if (response && response.status === 1) {
        setPurchaseOrders(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId !== purchaseRequestId.current) return false;
      showNotification(error.message || "Error", "Error");
    } finally {
      if (requestId === purchaseRequestId.current) {
        setIsLoadingPurchaseOrders(false);
      }
    }
  };

  const loadPurchaseOrderDetails = async (po_id) => {
    const requestId = ++purchaseDetailsRequestId.current;
    setPurchaseDetails({});
    setPurchaseDetailsModal(true);
    setIsLoadingPurchaseDetails(true);
    try {
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/user_purchaseorder_transactions";
      const response = await postSubmitForm(url, {
        adminuser_id: selectedRow._id,
        po_id: po_id,
      });
      if (requestId !== purchaseDetailsRequestId.current) return false;
      if (response && response.status === 1) {
        setPurchaseDetails((response.data && response.data[0]) || {});
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId !== purchaseDetailsRequestId.current) return false;
      showNotification(error.message || "Error", "Error");
    } finally {
      if (requestId === purchaseDetailsRequestId.current) {
        setIsLoadingPurchaseDetails(false);
      }
    }
  };

  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);
  useEffect(() => {
    if (allOrders.length > 0) {
      if (orderStatus === "All") {
        setFilteredOrders([...allOrders]);
      } else {
        let arr = allOrders.filter((order) => order.status === orderStatus);
        setFilteredOrders(arr);
      }
    }
  }, [allOrders, orderStatus]);
  const [productOrders, setProductOrders] = useState([]);
  const [itemOrders, setItemOrders] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);

  const [purchaseModal, setPurchaseModal] = useState(false);
  const [productModal, setProductModal] = useState(false);
  const [itemModal, setItemModal] = useState(false);

  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [directPurchaseDetailsModal, setDirectPurchaseDetailsModal] =
    useState(false);
  const [productDetailsModal, setProductDetailsModal] = useState(false);
  const [itemDetailsModal, setItemDetailsModal] = useState(false);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Userame"),
      dataField: "username",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Role"),
      dataField: "role",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Finished Products"),
      dataField: "role",

      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            style={{ cursor: "pointer" }}
            title="Click for details"
            onClick={() => {
              setSelectedRow(row);
              loadProductOrders(row._id);
            }}
          >
            <i class="bx bxs-folder-plus"></i> Show
          </span>
        );
      },
    },
    {
      text: props.t("Items"),
      dataField: "role",

      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            style={{ cursor: "pointer" }}
            title="Click for details"
            onClick={() => {
              setSelectedRow(row);
              loadItemOrders(row._id);
            }}
          >
            <i class="bx bxs-folder-plus"></i> Show
          </span>
        );
      },
    },
    {
      text: props.t("Purchase Orders"),
      dataField: "role",

      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            style={{ cursor: "pointer" }}
            title="Click for details"
            onClick={() => {
              setSelectedRow(row);
              loadPurchaseOrders(row._id);
            }}
          >
            <i class="bx bxs-folder-plus"></i> Show
          </span>
        );
      },
    },
  ];

  const columnsPurchase = [
    {
      dataField: "po_id",
      hidden: true,
    },
    {
      dataField: "po_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("PO"),
      dataField: "po_id",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setPurchaseDetails({});
              loadPurchaseOrderDetails(row.po_id);
            }}
          >
            {row.po_id}
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Branch Name"),
      sort: true,
      formatter: (cell, row) =>
        row.branch_details ? row.branch_details.name : "",
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Deliver at Branch"),
      sort: true,
      formatter: (cell, row) => (row.deliver_at_branch ? "Yes" : ""),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Supplier Name"),
      dataField: "supplier.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Supplier Mobile"),
      dataField: "supplier.mobile",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Date"),
      dataField: "createdAt",
      formatter: (cell, row, rowIndex) => {
        return moment(row.createdAt).format("DD/MM/YYYY");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Status"),
      dataField: "status",
      formatter: (cell, row, rowIndex) => {
        return row.status;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
  ];

  const columnsPurchaseDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,

      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "price",
      text: props.t("Price (QR)"),

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "total_price",
      text: props.t("Cost (QR)"),

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const columnsProduct = [
    {
      dataField: "order_id",
      hidden: true,
    },
    {
      dataField: "order_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Order"),
      dataField: "order_id",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setProductDetails({});
              loadProductOrderDetails(row.order_id);
            }}
          >
            {row.order_id}
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Branch"),
      dataField: "branch_details.name",

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Branch Remarks"),
      dataField: "remarks",

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Date"),
      dataField: "date_to_process",
      formatter: (cell, row, rowIndex) => {
        return moment(row.date_to_process).format("DD/MM/YYYY");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Status"),
      dataField: "status",
      formatter: (cell, row, rowIndex) => {
        return row.status;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
  ];

  const columnsProductDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Costing Unit"),
      dataField: "unit_for_cost_price",
      sort: true,

      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const columnsItem = [
    {
      dataField: "order_id",
      hidden: true,
    },
    {
      dataField: "order_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Order"),
      dataField: "order_id",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setItemDetails({});
              loadItemOrderDetails(row.order_id);
            }}
          >
            {row.order_id}
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Branch"),
      dataField: "branch_details.name",

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Branch Remarks"),
      dataField: "remarks",

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Date"),
      dataField: "date_to_process",
      formatter: (cell, row, rowIndex) => {
        return moment(row.date_to_process).format("DD/MM/YYYY");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Status"),
      dataField: "status",
      formatter: (cell, row, rowIndex) => {
        return row.status;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
  ];

  const columnsItemDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Purchasing Unit"),
      dataField: "unit_for_po",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };
  const modal_pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
    sizePerPage: 50,
  };

  const handleDownload = async () => {
    const fileName = "user_based_transaction_report_" + monthYear;
    const exportType = "xls";

    if (filteredOrders && filteredOrders.length > 0) {
      const data = filteredOrders.map((v) => ({
        Name: v.name,
        PurchaseCost: v.purchase_cost,
        ProductCost: v.product_cost,
        DirectCost: v.direct_purchase_cost,
        ItemCost: v.item_cost,
        TotalCost: v.total_cost,
      }));

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("User Based Transaction Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("User Based Transaction Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}></Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv0");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv0">
                    <CardTitle className="text-center">
                      {props.t("User Based Transaction Report")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      key={`${dateFrom}_${dateTo}`}
                      data={filteredOrders && filteredOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                                placeholder="  "
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* Purchase breakup modal       */}
          <Modal
            size="lg"
            isOpen={purchaseModal}
            toggle={() => setPurchaseModal(!purchaseModal)}
          >
            <ModalHeader toggle={() => setPurchaseModal(!purchaseModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("User Based Transaction Report")}
                      </CardTitle>
                    </Col>
                    <Col lg={4}></Col>
                  </Row>
                  <CardTitle className="text-center">
                    {" "}
                    {selectedRow.name}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Purchase Orders)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <BootstrapTable
                            keyField="_id"
                            data={purchaseOrders || []}
                            columns={columnsPurchase}
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            pagination={paginationFactory(
                              modal_pagination_options,
                            )}
                            noDataIndication={
                              isLoadingPurchaseOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Purchase breakup details modal       */}
          <Modal
            size="lg"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {props.t("Purchase Order Details")}
            </ModalHeader>
            <ModalBody>
              <>
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={12} md={12}>
                            <Label>Ordered Items</Label>
                          </Col>

                          <Col lg={12}>
                            <BootstrapTable
                              bootstrap4
                              keyField="_id"
                              data={
                                (purchaseDetails && purchaseDetails.items) || []
                              }
                              columns={columnsPurchaseDetails}
                              noDataIndication={
                                isLoadingPurchaseDetails ? (
                                  <Spinner size="md" />
                                ) : (
                                  "No data to display."
                                )
                              }
                              striped
                              hover
                              condensed
                            />
                            <hr />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            </ModalBody>
          </Modal>

          {/* Product breakup modal       */}
          <Modal
            size="lg"
            isOpen={productModal}
            toggle={() => setProductModal(!productModal)}
          >
            <ModalHeader toggle={() => setProductModal(!productModal)}>
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv3");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv3">
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <Row>
                            <Col lg={4}>
                              <img
                                src={logo}
                                alt=""
                                height="50"
                                style={{ borderRadius: "5px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <CardTitle className="text-center">
                                {props.t("User Based Transaction Report")}
                              </CardTitle>
                            </Col>
                            <Col lg={4}></Col>
                          </Row>
                          <CardTitle className="text-center">
                            {" "}
                            {selectedRow.name}
                          </CardTitle>

                          <CardTitle className="text-center">
                            {" "}
                            {props.t("(Product Orders)")}
                          </CardTitle>

                          <BootstrapTable
                            keyField="_id"
                            data={productOrders || []}
                            columns={columnsProduct}
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            pagination={paginationFactory(
                              modal_pagination_options,
                            )}
                            noDataIndication={
                              isLoadingProductOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product breakup details modal       */}
          <Modal
            size="lg"
            isOpen={productDetailsModal}
            toggle={() => setProductDetailsModal(!productDetailsModal)}
          >
            <ModalHeader
              toggle={() => setProductDetailsModal(!productDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProduct");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProduct">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("User Based Transaction Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <BootstrapTable
                            keyField="_id"
                            data={
                              (productDetails &&
                                productDetails.product_details) ||
                              []
                            }
                            columns={columnsProductDetails}
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingProductDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Item breakup modal       */}
          <Modal
            size="lg"
            isOpen={itemModal}
            toggle={() => setItemModal(!itemModal)}
          >
            <ModalHeader toggle={() => setItemModal(!itemModal)}>
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv4");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv4">
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <Row>
                            <Col lg={4}>
                              <img
                                src={logo}
                                alt=""
                                height="50"
                                style={{ borderRadius: "5px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <CardTitle className="text-center">
                                {props.t("User Based Transaction Report")}
                              </CardTitle>
                            </Col>
                            <Col lg={4}></Col>
                          </Row>
                          <CardTitle className="text-center">
                            {" "}
                            {selectedRow.name}
                          </CardTitle>
                          <CardTitle className="text-center">
                            {" "}
                            {props.t("(Item Orders)")}
                          </CardTitle>

                          <BootstrapTable
                            keyField="_id"
                            data={itemOrders || []}
                            columns={columnsItem}
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            pagination={paginationFactory(
                              modal_pagination_options,
                            )}
                            noDataIndication={
                              isLoadingItemOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item breakup details modal       */}
          <Modal
            size="lg"
            isOpen={itemDetailsModal}
            toggle={() => setItemDetailsModal(!itemDetailsModal)}
          >
            <ModalHeader toggle={() => setItemDetailsModal(!itemDetailsModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitem">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("User Based Transaction Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Item Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <BootstrapTable
                            keyField="_id"
                            data={
                              (itemDetails && itemDetails.item_details) || []
                            }
                            columns={columnsItemDetails}
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingItemOrderDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(UserBasedTransactionReport)),
);
